<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="4">
          <v-container fluid class="pa-8">
            <v-text-field
              ref="Channel_Name"
              v-model="Channel"
              label="Title*"
              outlined
              dense
              counter="40"
              :maximum="max"
            ></v-text-field>
            <croppa
              :placeholder-font-size="15"
              v-model="croppa"
              :width="190"
              :height="150"
              :canvas-color="'#E0E0E0'"
              crossorigin="anonymous"
              outlined
              :initial-image="initialIMage"
            />
            <v-textarea solo v-model="descriptnBroadcast" label="Description*"></v-textarea>

            <v-btn color="secondary" class="ml-15" @click="SendBroadcast()">Send Broadcast</v-btn>

            <v-dialog v-model="dialogBroadcast" width="600px">
              <v-card>
                <v-card-title class="secondary">
                  <span class="subtitle white--text">Send Broadcast</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="dialogBroadcastMethod()" class="white--text">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row align="center">
                      <v-col cols="12">
                        <v-select
                          :items="announcementList"
                          item-text="list_name"
                          item-value="list_data"
                          v-model="announcement"
                          label="Select List Name"
                        ></v-select>
                      </v-col>
                    </v-row>

                    <template>
                      <div class="text-center">
                        <v-btn
                          color="secondary"
                          :loading="loading"
                          @click="sendBroadcastToList()"
                          class="mt-5"
                        >Save</v-btn>
                      </div>
                    </template>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-container>
        </v-col>
        <v-col cols="12" sm="5"></v-col>
        <v-col cols="12" sm="3">
          <v-spacer></v-spacer>
          <div>
            <b>To:</b>
            <v-btn text small color="primary" @click="dialog=true">Select Surveyor</v-btn>
          </div>
          <v-dialog v-model="dialog" width="1100px">
            <v-card v-if="step==0">
              <v-card-title class="secondary">
                <span class="subtitle white--text">Select Surveyor</span>
                <v-spacer></v-spacer>
                <v-icon @click="dialogBroadcastMethod()" class="white--text">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col sm="12" md="8"></v-col>
                    <v-col sm="12" md="4">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="headers"
                    :items="subscribers"
                    :items-per-page="5"
                    item-key="name"
                    :search="search"
                    class="elevation-1"
                    v-model="selected"
                    dense
                  >
                    <template v-slot:item.checkData="{ item }">
                      <v-checkbox v-model="item.checkData" hide-details class="shrink mr-2 mt-0"></v-checkbox>
                    </template>
                  </v-data-table>
                  <template>
                    <div class="text-center">
                      <v-btn
                        color="secondary"
                        class="mt-5"
                        @click="deleteMethod(subscribers)"
                      >Delete</v-btn>
                    </div>
                  </template>
                </v-container>
              </v-card-text>
            </v-card>
            <v-card v-if="step==1">
              <v-card-title class="secondary">
                <span class="subtitle white--text">Select Surveyor</span>
                <v-spacer></v-spacer>
                <v-icon @click="dialogBroadcastMethod()" class="white--text">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col sm="12" md="8"></v-col>
                    <v-col sm="12" md="4">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="headersAfterDelete"
                    :items="tabledataAfterDelete"
                    :items-per-page="5"
                    item-key="name"
                    :search="search"
                    class="elevation-1"
                    v-model="selected"
                    dense
                  ></v-data-table>
                  <template>
                    <div class="text-center">
                      <v-btn color="primary" class="mt-5 mr-2" @click="backForToStep1('step0')">Back</v-btn>
                      <v-btn
                        color="secondary"
                        class="mt-5"
                        @click="saveAfterDelete(tabledataAfterDelete,'zero')"
                      >Next</v-btn>
                    </div>
                  </template>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogList" width="600px">
            <v-card>
              <v-card-title class="secondary">
                <span class="subtitle white--text">Select Surveyor</span>
                <v-spacer></v-spacer>
                <v-icon @click="dialogBroadcastMethod('step0')" class="white--text">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-text-field v-model="listName" label="List Name"></v-text-field>

                  <template>
                    <div class="text-center">
                      <v-btn color="primary" class="mt-5 mr-2" @click="backForToStep1('step1')">Back</v-btn>
                      <v-btn
                        color="secondary"
                        class="mt-5"
                        @click="saveAfterDelete(tabledataAfterDelete,'first')"
                      >Save</v-btn>
                    </div>
                  </template>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="alertPositive"
        color="secondary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
      <v-snackbar
        v-model="alertNegetive"
        color="primary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      alertPositive: false,
      alertNegetive: false,
      text: "",
      timeout: 2000,
      chooseImage: "",
      croppa: {},
      initialIMage: "",
      step: 0,
      max: 40,
      descriptnBroadcast: "",
      Channel: "",
      row: null,
      dialog: false,
      selected: [],
      dialogList: false,
      listName: "",
      loading: false,
      loader: null,
      dialogBroadcast: false,
      search: "",
      announcement: "",
      announcementList: [],
      singleSelect: false,
      subscribers: [],
      tabledataAfterDelete: [],
      headersAfterDelete: [
        { text: "Name", value: "serveyorname" },
        { text: "Phone no", value: "mobno", sortable: false },
        { text: "Email", value: "serveyoremail", width: 130, sortable: false },
        { text: "State", value: "surveyorstate", sortable: false },
        { text: "Zip", value: "surveyorzip", sortable: false },
        { text: "City", value: "surveyorcity", sortable: false },
        {
          text: "Surveyor type",
          value: "surveyor_type",
          width: 110,
          sortable: false
        }
      ],
      headers: [
        { type: "checkbox", value: "checkData", sortable: false },
        { text: "Name", value: "serveyorname" },
        { text: "Phone no", value: "mobno", sortable: false },
        { text: "Email", value: "serveyoremail", width: 130, sortable: false },
        { text: "State", value: "surveyorstate", sortable: false },
        { text: "Zip", value: "surveyorzip", sortable: false },
        { text: "City", value: "surveyorcity", sortable: false },
        {
          text: "Surveyor type",
          value: "surveyor_type",
          width: 110,
          sortable: false
        }
      ]
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 2000);

      this.loader = null;
    }
  },
  created() {
    this.getAllSurveyorsByOrgID();
  },
  methods: {
    async uploadMediaToS3() {
      if (this.croppa.hasImage()) {
        // console.log(this.croppa);
        var croppa_data = this.croppa.generateDataUrl("image/jpeg");
        // console.log(croppa_data);
        this.basedata = croppa_data.replace("data:image/jpeg;base64,", ""); // To remove base64 initial type image value, as server does not support it
        // console.log(this.basedata);

        var input = {
          file: this.basedata,
          type: 1,
          orgid: this.$store.getters.get_orgId,
          isLive: false
        };
        try {
          const res = await axios({
            method: "post",
            url:
              "https://2xvfkyu2eb.execute-api.us-east-1.amazonaws.com/adjustermateS3upload",
            data: input
          });
          var url = res.data.fileURL;
          // console.log(url);
          return url;
        } catch (error) {
          //console.log(error.response);
          return error.response;
        }
      } else {
        return null;
      }
    },

    async sendBroadcastToList() {
      if (this.announcement == "") {
        this.text = "Please Select List Name";
        this.alertNegetive = true;
      } else {
        this.loader = "loading";
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "NewAnnouncement_CreateNewAnnouncement",
          input: {
            text: this.Channel,
            mediatype: 1,
            mediaurl: await this.uploadMediaToS3(),
            orgid: this.$store.getters.get_orgId,
            type: 1,
            surveyoridarray: this.announcement,
            details: this.descriptnBroadcast
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var announcementList = res.data.data.data;
          console.log(announcementList);
          this.dialogBroadcast = false;
          this.announcement = [];
          this.Channel = "";
          this.text = "Successfully Sent";
          this.alertPositive = true;
          this.descriptnBroadcast = "";
          this.initialIMage = "";
          this.croppa.refresh();
        } catch (error) {
          console.log(error.response);
          return error.response;
        }
      }
    },
    async SendBroadcast() {
      if (this.Channel == "" || this.descriptnBroadcast == "") {
        this.text = "Please Enter mandatary Fields*";
        this.alertNegetive = true;
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "AnnouncementList_getAllAvailablelist",
          input: {
            orgid: this.$store.getters.get_orgId
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          this.announcementList = res.data.data.data;
          //    console.log(this.announcementList);
          this.dialogBroadcast = true;
        } catch (error) {
          //  console.log(error.response);
          return error.response;
        }
      }
    },
    dialogBroadcastMethod() {
      this.subscribers = [];
      console.log(this.subscribers);
      this.dialogBroadcast = false;
      this.getAllSurveyorsByOrgID();
      this.dialog = false;
      this.dialogList = false;
      this.step = 0;

      this.tabledataAfterDelete = [];
    },
    backForToStep1(type) {
      if (type == "step0") {
        this.step -= 1;
        this.subscribers = [];
        this.tabledataAfterDelete = [];
        this.getAllSurveyorsByOrgID();
      }
      if (type == "step1") {
        this.dialog = true;
        this.step = 1;
        this.dialogList = false;
      }
    },
    async saveAfterDelete(tabledataToPassApi, type) {
      if (type == "zero") {
        this.dialog = false;
        this.dialogList = true;
      }
      if (type == "first") {
        var arrayListData = [];
        tabledataToPassApi.forEach(function(element) {
          arrayListData.push(element.surveyorid);
        });

        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "AnnouncementList_createNewAnnouncementList",
          input: {
            listname: this.listName,
            orgid: this.$store.getters.get_orgId,
            cretaedby: this.$store.getters.get_UserAdminidId,
            listdata: arrayListData.join()
          }
        };
        //   console.log(input);
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          this.subscribers = res.data.data.data;
          this.text = "Successfully Created ";
          this.alertPositive = true;
          this.dialogBroadcastMethod();
        } catch (error) {
          //   console.log(error.response);
          return error.response;
        }
      }
    },
    deleteMethod(value) {
      //  console.log(value);
      var self = this;
      value.forEach(function(element) {
        if (element.checkData == false) {
          self.tabledataAfterDelete.push(element);
        }
      });
      //  console.log(self.tabledataAfterDelete);
      this.step++;
    },
    async getAllSurveyorsByOrgID() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetSurveyors_getAllSurveyorsByOrgID",
        input: {
          surveyor_orgid: this.$store.getters.get_orgId,
          status: 1
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.subscribers = res.data.data.data;
        this.subscribers.forEach(function(element) {
          element.checkData = false;
        });
      } catch (error) {
        //   console.log(error.response);
        return error.response;
      }
    }
  }
};
</script>
<style scoped>
/*Top menue before the table */
#TopMenue {
  height: 50px;
  margin: 0px 0px;
}
</style>